const FeatureManager = require('./featureManager-ts.js').FeatureManager;

module.exports = FeatureManager;
